import React, { Component } from 'react';
import orderBy from 'lodash/orderBy';
import classNames from 'classnames';
import getImage from './getImage';

class NewMenuItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      list: [],
    };
  }

  componentWillReceiveProps(nextProps) {
    let list = [];
    if (
      nextProps.category &&
      nextProps.halfCategory &&
      nextProps.halfCategory.length > 0
    ) {
      if (nextProps.halfCategory[0].selectedCategories) {
        let atms = nextProps.halfCategory[0].selectedCategories.filter(
          (item) => {
            return nextProps.category._id === item._id;
          }
        );
        if (atms.length > 0) {
          const halfHalfImage = getImage(
            nextProps.halfCategory[0].halfHalfPlaceholderPath ||
              nextProps.halfCategory[0].halfHalfPlaceholderImage ||
              '/assets/dummy.png'
          );
          let obj = {};
          obj.history = nextProps.history;
          obj.location = nextProps.location;
          obj.itemType = 'halfhalf';
          obj.item = atms[0];
          obj.displayOrder = -1;
          obj.totalRevenue = 1000000000000;
          obj.lazyLoad = false;
          obj.itemHandler = nextProps.showHalfViewHandler;
          obj.imgSrc = halfHalfImage;
          obj.bgImgSrc = halfHalfImage;
          obj.key = `halhalk23set`;
          obj.productName = 'HALF / HALF';
          obj.ingredients =
            atms[0].catName.substr(0, atms[0].catName.indexOf(' ')) +
            ' Half / Half Pizza';
          list.push(obj);
        }
      }

      nextProps.data &&
        nextProps.data.map((item, index) => {
          let obj = {};
          const { mediaPath, urlS3, url } = item;
          const itemImage = getImage(mediaPath || urlS3 || url);
          obj.history = nextProps.history;
          obj.location = nextProps.location;
          obj.itemType = this.props.itemType;
          obj.item = item;
          obj.displayOrder = item.displayOrder;
          obj.totalRevenue = item.totalRevenue;
          obj.lazyLoad = false;
          obj.itemHandler = nextProps.showMenuItemHandler;
          obj.imgSrc = nextProps.specialClass
            ? `https://assets.nextorder.co/assets/spPlaceholder.jpg`
            : `https://assets.nextorder.co/assets/placeholder.jpg`;
          obj.bgImgSrc = itemImage;
          obj.key = index;
          obj.price = nextProps.price(item);
          obj.productName = item.name;
          obj.ingredients = item.displayName
            ? item.displayName &&
              item.displayName.length > (window.innerWidth > 340 ? 40 : 25)
              ? item.displayName
                  .substr(0, window.innerWidth > 340 ? 36 : 25)
                  .substr(
                    0,
                    Math.min(
                      item.displayName.substr(
                        0,
                        window.innerWidth > 340 ? 36 : 25
                      ).length,
                      item.displayName
                        .substr(0, window.innerWidth > 340 ? 36 : 25)
                        .lastIndexOf(' ')
                    )
                  ) + '...'
              : item.displayName
            : item.description &&
              item.description.length > (window.innerWidth > 340 ? 40 : 25)
            ? item.description
                .substr(0, window.innerWidth > 340 ? 36 : 25)
                .substr(
                  0,
                  Math.min(
                    item.description.substr(
                      0,
                      window.innerWidth > 340 ? 36 : 25
                    ).length,
                    item.description
                      .substr(0, window.innerWidth > 340 ? 36 : 25)
                      .lastIndexOf(' ')
                  )
                ) + '...'
            : item.description;
          list.push(obj);
          return item;
        });
    } else {
      nextProps.data &&
        nextProps.data.map((item, index) => {
          let obj = {};
          const { mediaPath, urlS3, url } = item;
          const itemImage = getImage(mediaPath || urlS3 || url);
          obj.history = nextProps.history;
          obj.location = nextProps.location;
          obj.itemType = this.props.itemType;
          obj.item = item;
          obj.displayOrder = item.displayOrder;
          obj.totalRevenue = item.totalRevenue;
          obj.lazyLoad = false;
          obj.itemHandler = nextProps.showMenuItemHandler;
          obj.imgSrc = nextProps.specialClass
            ? `https://assets.nextorder.co/assets/spPlaceholder.jpg`
            : `https://assets.nextorder.co/assets/placeholder.jpg`;
          obj.bgImgSrc = itemImage;
          obj.key = index;
          obj.price = nextProps.price(item);
          obj.productName = item.name;
          obj.ingredients = item.displayName
            ? item.displayName &&
              item.displayName.length > (window.innerWidth > 340 ? 40 : 25)
              ? item.displayName
                  .substr(0, window.innerWidth > 340 ? 36 : 25)
                  .substr(
                    0,
                    Math.min(
                      item.displayName.substr(
                        0,
                        window.innerWidth > 340 ? 36 : 25
                      ).length,
                      item.displayName
                        .substr(0, window.innerWidth > 340 ? 36 : 25)
                        .lastIndexOf(' ')
                    )
                  ) + '...'
              : item.displayName
            : item.description &&
              item.description.length > (window.innerWidth > 340 ? 40 : 25)
            ? item.description
                .substr(0, window.innerWidth > 340 ? 36 : 25)
                .substr(
                  0,
                  Math.min(
                    item.description.substr(
                      0,
                      window.innerWidth > 340 ? 36 : 25
                    ).length,
                    item.description
                      .substr(0, window.innerWidth > 340 ? 36 : 25)
                      .lastIndexOf(' ')
                  )
                ) + '...'
            : item.description;
          list.push(obj);
          return item;
        });
    }
    if (
      (nextProps.category && nextProps.category.sortingType === '2') ||
      (nextProps.itemType && nextProps.itemType === 'specials')
    ) {
      list = orderBy(list, ['displayOrder'], ['asc']);
    } else {
      list = orderBy(list, ['totalRevenue'], ['desc']);
    }

    this.setState({ list });
  }

  getClassName = () => {
    if (this.props.activeSlideIndex === this.props.slideIndex) {
      return (
        'md-' + this.props.slideIndex + ' ' + this.props.specialClass &&
        this.props.specialClass + ' active'
      );
    } else if (
      this.props.activeSlideIndex === this.props.slideIndex - 1 ||
      this.props.activeSlideIndex === this.props.slideIndex + 1
    )
      return (
        'sibling md-' + this.props.slideIndex + ' ' + this.props.specialClass
      );
    else return 'md-' + this.props.slideIndex + ' ' + this.props.specialClass;
  };

  renderMenuItem = (menuItem, item) => {
    let sectionStyle = {
      backgroundImage: `url(${item.bgImgSrc})`,
    };

    let disableClickClass = classNames({
      'disable-click': item.price === 'Sold Out',
    });

    let halfHalfClass = classNames({
      imgWrap: true,
      'swiper-lazy': menuItem.lazyLoad,
    });

    return (
      <li className={'itemBoxes boxWrapper'}>
        <div className='itemInnerWrap'>
          <div
            className={halfHalfClass}
            data-background={item.bgImgSrc}
            style={item.lazyLoad ? { visibility: 'visible' } : sectionStyle}
          >
            <img src={item.imgSrc} alt='img' className='proimg' />
            <div className='prodInfo'>
              {item.price && item.item.type !== '2' && (
                <div
                  className={
                    !item.item.isAvailable &&
                    (item.itemType === 'menuitem' ||
                      item.itemType === 'specials') &&
                    item.price === 'Sold Out'
                      ? 'prodPrice redFont'
                      : 'prodPrice'
                  }
                >
                  {item.price}
                </div>
              )}
              <div className='prodname'>
                {item.productName &&
                item.productName.indexOf(' ') === -1 &&
                item.productName.length > 10
                  ? item.productName.match(/.{1,10}/g).join('­')
                  : item.productName}
              </div>
            </div>
          </div>
          <div className='prodIngredients'>
            <span className='innerIng'>{item.ingredients}</span>
          </div>

          <a
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
            }}
            href={
              item.item.name &&
              `/${item.itemType}/${item.item.name
                .trim()
                .replace(/ /g, '')
                .toLowerCase()}${item.item._id}`
            }
            className={disableClickClass}
          >
            {item.productName}
          </a>
        </div>
      </li>
    );
  };

  render() {
    if (
      this.props.itemType === 'menuitem' ||
      this.props.itemType === 'specials'
    ) {
      return (
        this.state.list.length > 0 && (
          <div
            key={this.props.slideIndex}
            className='tabsSlider--tab'
            data-id={this.props.slideIndex}
          >
            <React.Fragment>
              <ul style={{ listStyleType: 'none', paddingLeft: '0px' }}>
                {this.state.list.map((menuItem, index) => {
                  let item = {
                    bgImgSrc: menuItem.bgImgSrc,
                    lazyLoad: menuItem.lazyLoad,
                    imgSrc: menuItem.imgSrc,
                    price: menuItem.price,
                    productName: menuItem.productName,
                    ingredients: menuItem.ingredients,
                    itemType: menuItem.itemType,
                    item: menuItem.item,
                    location: menuItem.location,
                    history: menuItem.history,
                    itemHandler: menuItem.itemHandler,
                  };
                  return (
                    <React.Fragment key={index}>
                      {this.renderMenuItem(menuItem, item)}
                    </React.Fragment>
                  );
                })}
              </ul>
            </React.Fragment>
          </div>
        )
      );
    }
  }
}

export default NewMenuItem;
